var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
var SearchBar = /** @class */ (function (_super) {
    __extends(SearchBar, _super);
    /**
     *
     * @param props
     */
    function SearchBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { value: props.value ? props.value : '' };
        _this.onChange = _this.onChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.clear = _this.clear.bind(_this);
        return _this;
    }
    /**
     *
     * @return {*}
     */
    SearchBar.prototype.render = function () {
        var _a = this.props, placeholder = _a.placeholder, className = _a.className;
        var value = this.state.value;
        return (React.createElement("form", { onChange: this.onChange, onSubmit: this.onSubmit, className: className },
            React.createElement("div", { className: "input-group input-group-lg input-group-rounded input-group-merge" },
                React.createElement("input", { type: "search", className: "form-control form-control-prepended form-control-appended search h-100", placeholder: placeholder, onChange: function () {
                    }, value: value }),
                React.createElement("div", { className: "input-group-prepend" },
                    React.createElement("div", { className: "input-group-text" },
                        React.createElement("span", { className: "fe fe-search small" }))),
                React.createElement("div", { className: "input-group-append" },
                    React.createElement("div", { className: "input-group-text" }, value && value.length > 0 ?
                        React.createElement("span", { className: "fe fe-x cursor-pointer small", onClick: this.clear }) : null)))));
    };
    /**
     *
     * @param event
     */
    SearchBar.prototype.onChange = function (event) {
        var searchValue = event.target.value;
        this.setState({ value: searchValue });
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(searchValue);
        }
    };
    /**
     *
     */
    SearchBar.prototype.onSubmit = function (event) {
        event.preventDefault();
        var onSubmit = this.props.onSubmit;
        var value = this.state.value;
        if (onSubmit) {
            onSubmit(value);
        }
    };
    /**
     *
     */
    SearchBar.prototype.clear = function () {
        var onChange = this.props.onChange;
        this.setState({ value: '' });
        if (onChange) {
            onChange('');
        }
    };
    SearchBar.defaultProps = {
        placeholder: 'zoek',
        value: '',
        className: ''
    };
    return SearchBar;
}(React.Component));
export default SearchBar;
